import { render, staticRenderFns } from "./faceRecognition.vue?vue&type=template&id=0b9b56a9&scoped=true&"
import script from "./faceRecognition.vue?vue&type=script&lang=js&"
export * from "./faceRecognition.vue?vue&type=script&lang=js&"
import style0 from "./faceRecognition.vue?vue&type=style&index=0&id=0b9b56a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9b56a9",
  null
  
)

export default component.exports